import RoutingActions from '../../../actions/RoutingActions';
import GuestListActions from '../../../actions/GuestListActions';
import PopupActions from '../../../actions/PopupActions';
import NotificationActions from '../../../actions/NotificationActions';
import UserStore from '../../../stores/UserStore';
import DD from '../../form/dropdown/DD.react';
import GuestActions from '../../../actions/GuestActions';
import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as EndPoints } from '../../../constants/GuestConstants';

class CheckInCaregiver extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading : false,
            caregivers : [],
            CaregiverMJStateIdNo : null,
            caregiverName : '',
            showBirthdateCheck: false,
            birthdateCheckComplete: false
        };

        this.fetchCaregivers = this.fetchCaregivers.bind(this);
        this.openCaregiverSelection = this.openCaregiverSelection.bind(this);
        this.checkInCaregiver = this.checkInCaregiver.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        this.fetchCaregivers();
    }

    validate() {
		if(!!UserStore.getState().selectedLocation.RequireDoctorForCheckIn) {
			if(!(parseInt(this.props.guest.doctor) > 0)) {
	            NotificationActions.addNotification({
	                type : 'alert',
	                body : 'Patient does not have a doctor on record.'
				});
                return false;
            }
        }   
        
        if (this.props.guest.status != 'Active') {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'Patient is ' + this.props.guest.status + '.'
            });
            return true;
        }

        return true;
    }

    fetchCaregivers() {
        var formData        = UserStore.getApiData();
        formData.guest_id   = this.props.guest.Guest_id;
        AjaxPromises.POST(EndPoints.GET_CAREGIVER_LIST, formData).then(res => {
            if(res.Result) {
                this.setState({ caregivers: res.Data, CaregiverMJStateIdNo: 0 });
            } else if(!res.Result) {
                NotificationActions.error(`Caregiver list failed to load: ${res.Message}`);
            }
        });
    }

    openCaregiverSelection(valid) {
        if (!valid) {
            this.validate();
            return
        }

        this.setState({ loading : true });
    }

    selectCaregiver(CaregiverMJStateIdNo) {
        this.setState({ CaregiverMJStateIdNo });
    }

    isCaregiverSelected() {
        return this.state.CaregiverMJStateIdNo !== 0;
    }

	checkInCaregiver(toPos) {
        if (!this.isCaregiverSelected()) {
            return;
        }

        if (toPos && !UserStore.getState().selectedRegister) {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'Please select a register first'
            });
            return;
        }

        //Does this logic belong to the action?
        GuestListActions.checkGuestInCaregiver(this.props.guest, this.state.CaregiverMJStateIdNo, toPos)
            .then((x) => {
                if (toPos) {
                    var success = x.Result === true;

                    if (success) {
                        this.setState({ loading : false });
                        var guest = this.props.guest;
                        guest.ShipmentId = x.Data[0].ShipmentId;
                        RoutingActions.updateRoute('pos/'+guest.Guest_id);
                        GuestListActions.selectGuestForPos(guest); //Probably skip this?  seems like it should happen in the server side call?
                        PopupActions.close(); //TODO: Y THO
                    }
                } else {
                    this.setState({ loading : false });
                    GuestListActions.loadGuestList(false);
                    RoutingActions.updateRoute('guest-list');
                    PopupActions.close();  //  TODO: ytho?
                }
            });
    }

    render() {
        var valid = !(this.props.selectedLocation.BlockBannedPatientCheckin && this.props.guest.status == 'Banned');
        return (
            <div>
                <button
                    className={'btn-green '+(!valid ? 'btn-green__disabled' : '')}
                    onClick={() => this.openCaregiverSelection(valid)}
                    disabled={false}>

                    { this.state.loading ? 'Loading' : 'CHECK IN CAREGIVER' }
                </button>

                {this.state.loading &&
                <div className='popup popup__transparent'>
                    <div className='popup__content w-25'>
                        <div className='popup-header'>
                            Select Caregiver

                            <div
                                className='popup-close'
                                onClick={() => { this.setState({ loading : false }) }}>

                                <i className='fa fa-times' aria-hidden='true' />
                            </div>
                        </div>

                        <DD
                            options={[{ title: '- None -', option: '' }]
                            .concat(this.state.caregivers.map(x => {
                                return { title: x.CaregiverName, option: x.CaregiverMJStateIDNo }
                            }))}
                            value={this.state.CaregiverMJStateIdNo}
                            onChange={CaregiverMJStateIdNo => this.selectCaregiver(CaregiverMJStateIdNo)} 
                        />
                        <button
                            className={'btn-green '+(!this.isCaregiverSelected() ? 'btn-green__disabled' : '')}
                            onClick={() => {this.checkInCaregiver(false)}}
                            disabled={!this.isCaregiverSelected()}
                            >

                            Check In
                        </button>
                        <button
                            className={'mb-4 btn-green '+(!this.isCaregiverSelected() ? 'btn-green__disabled' : '')}
                            onClick={() => {this.checkInCaregiver(true)}}
                            disabled={!this.isCaregiverSelected()}
                            >

                            Check In To POS
                        </button>
                    </div>
                </div>
                }
            </div>
        );
    }
}

export default CheckInCaregiver;



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/sidebar/CheckInCaregiver.react.jsx